export const clearOfficerDraftCache = () => {
  localStorage.removeItem('extractedOfficers')
  localStorage.removeItem('uenExtractedDocDetail')
}
